import { ImageMediaEntity } from '@/pages/AdvancedEditor/components/panels/media/types';
import styled from '@emotion/styled';
import { useState } from 'react';
import { DeleteButton, InfoTag, Loader, TileContainer, TileTitle } from './common';

const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

interface Props {
    entity: ImageMediaEntity;
    width: number;
    height: number;
    onDelete: () => Promise<void>;
    onClick: () => void;
}

export const GifTile = ({ entity, width, height, onDelete, onClick }: Props) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <TileContainer width={width} height={height} onClick={entity.isLoading ? undefined : onClick} isLoading={entity.isLoading}>
            {entity.isLoading && <Loader />}
            <DeleteButton className="only-hover" onClick={onDelete} />
            <TileTitle className="only-hover">{entity.filename}</TileTitle>
            <InfoTag content="GIF" />

            <ImageWrapper onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                {isHovered && entity.src ? <StyledImage src={entity.src} /> : <StyledImage src={entity.thumbnail} />}
            </ImageWrapper>
        </TileContainer>
    );
};
